import { useMemo } from 'react';

import IcStatsChallenge from '@/assets/tournaments/ic_challenge_stats.svg';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { Maybe } from '@/types';
import { ChallengeInitResponse } from '@/types/challenges';

interface Props {
  init: Maybe<ChallengeInitResponse>;
}

export const ChallengeTotalStats = ({ init }: Props) => {
  const { isMobile } = useIsDesktop();

  const stats = useMemo(() => {
    return [
      {
        label: 'JUGADOS',
        value: init?.hist_jugados ? `${init?.hist_jugados}` : '-',
      },
      {
        label: 'GANADOS',
        value: init?.hist_ganados ? `${init?.hist_ganados}` : '-',
      },
      {
        label: 'EMPATADOS',
        value: init?.hist_empatados ? `${init?.hist_empatados}` : '-',
      },
      {
        label: 'PERDIDOS',
        value: init?.hist_perdidos ? `${init?.hist_perdidos}` : '-',
      },
    ];
  }, [init]);

  return (
    <div
      className={`
    p-4 bg-white rounded-xl shadow-md
    ${isMobile ? 'max-w-[calc(100%-3rem)] mx-auto' : 'w-full'}
  `}
    >
      <div className="flex items-center space-x-3 mb-4">
        <div className="bg-indigo-100 p-2 rounded-full flex items-center justify-center">
          <img
            alt="estadisticas"
            className={isMobile ? 'w-4 h-4' : 'w-6 h-6'}
            src={IcStatsChallenge}
          />
        </div>
        <h2
          className={
            isMobile
              ? 'text-lg font-semibold text-gray-900'
              : 'text-lg font-semibold text-gray-900'
          }
        >
          Tus estadísticas totales
        </h2>
      </div>

      <hr className="mb-4" />

      {/* Mobile → flex fila, Desktop → grid 4 col */}
      {isMobile ? (
        <div className="flex justify-around text-center">
          {stats.map((stat) => (
            <div key={stat.label} className="flex-1">
              <p className="text-[12px] text-gray-400 font-medium">
                {stat.label}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {stat.value}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-4 text-center gap-y-4">
          {stats.map((stat) => (
            <div key={stat.label}>
              <p className="text-xs text-gray-400 font-medium">{stat.label}</p>
              <p className="text-lg font-semibold text-gray-900">
                {stat.value}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
